import React, { useState } from "react";
import axios from "axios";

import Formimage from "./Images/Formimage.svg";

const Getintouch = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      // API endpoint URL
      const apiUrl = "https://rmbbackend.rmbjaipur.com/auth/getintouch"; // Replace with your API URL

      // Sending data to the API
      const response = await axios.post(apiUrl, formData);

      // Handle successful response
      setStatus("Form submitted successfully!");
      console.log("Response:", response.data);
    } catch (error) {
      // Handle errors
      setStatus("Failed to submit the form. Please try again.");
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <div className="bg-[#1E2A3A] py-14 px-[8%]">
        <h2 className="text-[39px] text-[#FDBC12] font-bold text-center">
          Get in Touch with Us
        </h2>
        <p className="text-[16px] text-[#CBD5E0] text-center mt-5">
          Have questions or want to know more about our upcoming events? Get in
          touch with us today and explore opportunities <br /> to grow your
          business and contribute to your community.
        </p>

        <div className="w-[100%] flex flex-wrap bg-[#344056] border-2 border-[#94A2B8] rounded-3xl mt-[50px]">
          <div className="xl:w-[50%] w-[100%] p-0 hidden xl:block">
            <img className="w-[100%]" src={Formimage} alt="Form illustration" />
          </div>
          <div className="xl:w-[50%] w-[100%] p-[42px]">
            <form onSubmit={handleSubmit}>
              <section className="flex flex-col gap-2">
                <label htmlFor="name" className="uppercase text-[#D7D3D2]">
                  Name
                </label>
                <div className="w-[100%] h-[50px] border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <label htmlFor="email" className="uppercase text-[#D7D3D2] mt-5">
                  Email
                </label>
                <div className="w-[100%] h-[50px] border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email Address"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <label htmlFor="mobile" className="uppercase text-[#D7D3D2] mt-5">
                  Mobile Number
                </label>
                <div className="w-[100%] h-[50px] border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center">
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Enter Mobile Number"
                    className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8]"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>
                <label htmlFor="message" className="uppercase text-[#D7D3D2] mt-5">
                  Message
                </label>
                <div className="w-[100%]">
                  <textarea
                    name="message"
                    placeholder="Type Here"
                    className="w-full h-[142px] border px-2 border-[#94A2B8] rounded-lg pt-3 bg-transparent placeholder-[#94A2B8] outline-none text-[#94A2B8] mt-5"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>
                <button
                  type="submit"
                  className="bg-[#FDBC12] h-[50px] text-[16px] text-[#101729] rounded-lg mt-8"
                >
                  Submit
                </button>
                {status && <p className="text-[#FDBC12] mt-4">{status}</p>}
              </section>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Getintouch;
